module.exports = __webpack_public_path__ + "media/landing/slider-4-d4dc2c6c.jpeg";